<template>
  <div id="myCoupon" ref="noCharge">
    <div class="navlist">
      <div style="display:flex;">
        <div
          class="nav"
          v-for="(item,index) in nav"
          :key="index"
          :class="navState===index?'pick_nav':''"
          @click="switchNav(index)"
        >{{item.name}}</div>
      </div>
      <div class="explain" @mouseover="lookuse()" ref="tip">
        礼券使用说明
        <i class="fa fa-wenhao"></i>
        <div class="use_info" v-show="useState" >
          <i class="top"></i>
          <p v-for="(item,index) in useInfo" :key="index">{{item.data}}</p>
        </div>
      </div>
    </div>
    <div class="couponlist" v-if="couponList.length>0">
      <div v-for="(item,index) in couponList" :key="index" class="coupon">
        <Coupon :couponInfo="item"></Coupon>
      </div>
    </div>
    <div v-else-if="couponList.length===0" class="couponList_empty">
      <div>
      <img :src="empty" alt="">
      <div class="empty_text">{{emptyWarn}}</div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api'
import Coupon from '@/components/Coupon'
import moment from 'moment'
export default {
  data () {
    return {
      nav: [{ name: '待使用' }, { name: '已使用' }, { name: '已过期' }],
      emptyWarn: '',
      navState: 0,
      couponState: 1,
      page: 1,
      pageSize: 12,
      useState: false,
      couponType: 'mycoupon',
      total: 0,
      empty: require('@/assets/img/coupon/empty.png'),
      replyData: [],
      // noMore: false,
      couponList: [
      ],
      useInfo: [
        {
          data:
            '1. 礼券仅可以在购买质心官网 / 质心灵动量网站的课程时使用，不找零、无法兑现。'
        },
        {
          data:
            '2. 不同礼券适用于不同的课程，且只支持用于购买整个课程(即购买部分小课时无法使用礼券)。'
        },
        {
          data: ' 3. 礼券不可叠加使用，每个订单最多使用一张礼券。'
        },
        {
          data:
            '4. 礼券有有效时间限制，以礼券上显示的结束日期为准，超过日期后则无法使用。'
        },
        {
          data:
            '5. 生成订单后，所选的礼券会被锁定无法用于其它订单。若订单取消，则返还礼券。'
        },
        {
          data: '6. 付款成功后，退款时不会返还礼券。'
        },
        {
          data: ' 7. 礼券的最终解释权归质心教育所有。'
        }
      ],
      onPullDown: false, // 下拉加载
      isEnd: true // 下拉加载
    }
  },
  components: {
    Coupon
  },
  methods: {
    scroll () {
      var that = this
      // scrollTop 滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop + document.body.scrollTop
      // windowHeight 可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      // scrollHeight 滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (
        scrollTop + windowHeight + 200 > scrollHeight &&
        that.onPullDown === true &&
        that.isEnd === true
      ) {
        that.onPullDown = false
        // 加载数据
        that.page = that.page + 1
        this.getCoupon()
      }
    },
    lookuse () {
      this.useState = !this.useState
    },
    switchNav (e) {
      this.navState = e
      this.couponState = e + 1
      this.couponList = []
      this.page = 1
      this.getCoupon()
    },
    closeTip (e) {
      if (!this.$refs.tip.contains(e.target)) {
        this.useState = false
      }
    },
    getCoupon () {
      const params = {
        state: this.couponState,
        course_belong: '质心灵动量',
        page: this.page,
        page_size: this.pageSize
      }
      if (params.state === 1) {
        this.emptyWarn = '目前没有待使用的礼券'
      } else if (params.state === 2) {
        this.emptyWarn = '目前没有已使用的礼券'
      } else if (params.state === 3) {
        this.emptyWarn = '目前没有已过期的礼券'
      }
      api
        .getCoupon(params)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data.list || []
            this.total = r.data.data.total
            this.replyData = item
            if (!item) {
              return false
            } else if (item && item.length === 0) {
              return false
            }
            const arr = item.map(item => {
              let couponState
              if (params.state === 1) {
                couponState = 0
              } else if (params.state === 2) {
                couponState = 1
              } else if (params.state === 3) {
                couponState = 2
              }
              const couponType = 'mycoupon'
              const warnState = 0
              const price = item.coupon_val / 100
              const date =
                moment.unix(item.start_time).format('YYYY.MM.DD') +
                '-' +
                moment.unix(item.end_time).format('YYYY.MM.DD')
              const title = item.title.slice(0, 12)
              let warn
              if (item.all_course) {
                if (item.goods_type === 5) {
                  warn = '适用范围：' + '面授课中，全部课程可用'
                } else if (item.goods_type === 2) {
                  warn = '适用范围：' + '直播课中，全部课程可用'
                }
              } else {
                if (item.goods_type === 5) {
                  warn = '适用范围：面授课中，' + item.course_fullname + '可用'
                } else if (item.goods_type === 2) {
                  warn = '适用范围：直播课中，' + item.course_fullname + '可用'
                }
              }
              return {
                couponType,
                couponState,
                price,
                date,
                title,
                warnState,
                warn
              }
            })
            this.couponList = this.couponList.concat(arr)
            if (item.length > 0) {
              this.isEnd = true
            } else {
              this.isEnd = false
            }
            this.$nextTick(() => {
              this.onPullDown = true
            })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    }
  },
  created () {
    this.getCoupon()
    document.addEventListener('click', this.closeTip)
  },
  mounted () {
    window.addEventListener('scroll', this.scroll, true) // 监听（绑定）滚轮滚动事件
  },
  destroyed () {
    document.removeEventListener('click', this.closeTip)
    window.removeEventListener('scroll', this.scroll, true)
  }
}
</script>
<style  lang="scss">
#myCoupon {
  margin: auto;
  background: white;
  margin-top: 16px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 20px;
  min-height: 575px;
  .navlist {
    height: 51px;
    box-sizing: border-box;
    margin: auto;
    display: flex;
    border-bottom: 1px solid rgba(51, 51, 51, 0.1);
    justify-content: space-between;
    .nav {
      line-height: 51px;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      margin-right: 48px;
      cursor: pointer;
    }
    .explain {
      font-size: 14px;
      color: rgba(51, 51, 51, 0.6);
      position: relative;
      line-height: 51px;
      i {
        margin-left: 4px;
      }
      .use_info {
        position: absolute;
        width: 605px;
        height: auto;
        box-shadow: 0px 1px 12px 0px rgba(186, 196, 205, 0.37);
        background: white;
        z-index: 2;
        right: 0px;
        top: 52px;
        box-sizing: border-box;
        padding: 27px 16px 15px 24px;
        font-size: 13px;
        line-height: 23px;
        .top {
          position: absolute;
          top: -19px;
          right: 72px;
        }
        .top:before,
        .top:after {
          position: absolute;
          content: "";
          border-top: 10px transparent dashed;
          border-left: 10px transparent dashed;
          border-right: 10px transparent dashed;
          border-bottom: 10px #fff solid;
        }
        .top:before {
          border-bottom: 10px rgba(51, 51, 51, 0.1) solid;
        }
        .top:after {
          top: 1px; /*覆盖并错开1px*/
          border-bottom: 10px #fff solid;
        }
      }
    }
    .pick_nav {
      font-size: 18px;
      color: rgba(0, 199, 191, 1);
      font-weight: 500;
      position: relative;
    }
    .pick_nav::after {
      position: absolute;
      bottom: 0;
      left: 0px;
      right: 20px;
      height: 2px;
      width: 54px;
      background: rgba(0, 199, 191, 1);
      content: "";
    }
  }
  .couponlist {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    // min-height: 500px;
    .coupon {
      margin-top: 32px;
    }
  }
  .couponlist:after {
    // 使用伪类元素占据单位，不影响页面
    content: "";
    height: 0;
    width: 30%;
  }
  .couponList_empty{
        display: flex;
    height: 500px;
    justify-content: center;
    align-items: center;
    color: rgba(51, 51, 51, 0.6);
    font-size: 14px;
    img{
      width: 146px;
      height: 146px;
    }
    .empty_text{
      text-align: center;
      margin-top: 20px;
    }
  }
}
@media (min-width: 320px) {
#myCoupon{
.navlist{
.nav{
margin-right: 17px;
}
}
}
}
@media (min-width: 375px) {
  #myCoupon {
    padding: 0px 0px 10px 10px;
    .navlist {
      padding-right: 11px;
      .nav {
        margin-right: 25px;
      }
      .explain {
        .use_info {
          width: 335px;
          right: 9px;
        }
      }
    }
  }
}
@media (min-width: 414px) {
  #myCoupon {
    width: 403px;
    .navlist {
      .nav {
        margin-right: 18px;
      }
    }
  }
}
@media (min-width: 768px) {
  #myCoupon {
    width: 759px;
    padding: 0px 24px 24px 24px;
  }
}
@media (min-width: 1024px) {
  #myCoupon {
    width: 807px;
    padding: 0px 24px 24px 24px;
  }
}
@media (min-width: 1300px) {
  #myCoupon {
    width: 1140px;
    padding: 0px 24px 24px 24px;
    .navlist {
      .nav {
        margin-right: 48px;
      }
      .explain {
        .use_info {
          width: 605px;
          right: -14px;
        }
      }
    }
  }
}
</style>
